export default "__VITE_ASSET__dcNu5p3K__"